import AddCircle from '@mui/icons-material/AddCircle';
import { ListItemIcon, ListItemText, ListItemButton } from '@mui/material';
import { useHistory } from 'react-router-dom';
import useStyles from './styles.ts';
import clsx from 'clsx';

import { useTranslation } from 'react-i18next';
import type { I18nScenarioSectionNs } from '@/i18n/dictionaries/interfaces.ts';
import { I18nNamespace } from '@/i18n/types/i18nNamespace.ts';
import AppRoutes from 'app/utils/routes.ts';

export default function AddScenarioSection() {
  const [translate] = useTranslation(I18nNamespace.ScenarioSection);
  const history = useHistory();
  const classes = useStyles();

  return (
    <ListItemButton onClick={() => history.push(AppRoutes.SceneNew)} data-cy="createScenarioButton">
      <ListItemIcon color="primary" className={clsx(classes.iconMWidth24, classes.paddingRight10)}>
        <AddCircle classes={{ root: classes.addBtn }} />
      </ListItemIcon>
      <ListItemText
        classes={{ root: classes.addBtn }}
        primary={translate(nameof.full<I18nScenarioSectionNs>((l) => l.createNewScenario))}
      />
    </ListItemButton>
  );
}
